
if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // Die Leiste enthaelt seit 27.08.2026 einen echten Kaufbutton statt eines
      // Ankers. Preis und Verfuegbarkeit muessen der gewaehlten Variante folgen.
      this.addBtn = this.querySelector('.sticky-atc-panel__add');
      this.priceEl = this.querySelector('.price');
      this.sourcePriceEl = this.productInfo ? this.productInfo.querySelector('.price') : null;
      this.bindVariantChange();

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Keeps price and availability in the sticky panel in sync with the
     * selected variant.
     *
     * The price is mirrored from the info column instead of being formatted
     * again here: variant-picker.js already updated it by the time the event
     * fires (updatePrice runs before dispatchEvent), so mirroring cannot drift
     * from what the customer sees above.
     */
    bindVariantChange() {
      if (!this.productSection || !this.addBtn) return;

      this.productSection.addEventListener('on:variant:change', (evt) => {
        if (this.priceEl && this.sourcePriceEl) {
          this.priceEl.innerHTML = this.sourcePriceEl.innerHTML;
        }

        const variant = evt.detail && evt.detail.variant;
        const available = !!(variant && variant.available);
        this.addBtn.disabled = !available;
        this.addBtn.textContent = available
          ? this.addBtn.dataset.addText
          : this.addBtn.dataset.soldoutText;
      });
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
